<template>
  <v-card flat :width="width" :class="{ 'card-style-active': isClicked }" @click="readProduct(idx)" style="cursor: pointer; background-color: transparent;">
    <v-img :src="thumbnailSrc" :aspect-ratio="16/9" style="padding: 6px; border-radius: 2px; margin-bottom: 10px;"
           :gradient="status === 'earlybird' && publishedAt ? 'to top, rgba(0, 0, 0, 0.5) 0%, transparent 50%' : null">
      <v-container fulid pa-0 ma-0 fill-height>
        <v-layout column align-end class="pa-0 ma-0">
          <v-btn icon small @click.prevent.stop="bookmark" class="ma-0 pa-0">
            <v-icon color="white">{{ bookmarks ? '$vuetify.icons.heartFilled' : '$vuetify.icons.heartTwoTone' }}</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <span class="sub-text-style sub-date" style="color: white">
            {{ status === 'earlybird' && publishedAt ? `${new Date(publishedAt).getMonth() + 1}월 ${new Date(publishedAt).getDate()}일 런칭`: '' }}
          </span>
        </v-layout>
      </v-container>
    </v-img>

    <v-card-text class="pa-0 text-xs-left" v-if="typeof subtitle === 'string'" style="line-height: 10px; margin-bottom: 6px;">
      <span class="sub-text-style sub-title" :style="{ color: subtitle_color }"
            style="font-size: 10px; letter-spacing: -0.2px; font-weight: 700;">
        {{ subtitle }}
      </span>
    </v-card-text>

    <v-card-title primary-title class="pa-0 text-xs-left align-start line-clamping" style="min-height: 42px;">
      <span class="body-2 mb-0" v-text="title"></span>
    </v-card-title>

    <v-card-actions v-if="typeof alarms === 'boolean'" class="pa-0 pt-2">
      <v-btn depressed small dark color="#ec514f" block style="border-radius: 5px;"
             @click.prevent.stop="alarm"
             v-if="alarms">
        <v-icon size="16px">$vuetify.icons.confirm</v-icon>
        <v-divider vertical class="ml-2 mr-2" style="margin-top: 5px; height: 10px; border-color: white; max-height: unset;"></v-divider>
        <span class="button-font">알림 신청중</span>
      </v-btn>
      <v-btn flat small color="primary" block style="background-color: #ffeaea; border-radius: 5px;"
             @click.prevent.stop="alarm"
             v-else>
        <v-icon>$vuetify.icons.notification</v-icon>
        <v-divider vertical class="ml-1 mr-2" style="margin-top: 7px; height: 10px; border-color: rgba(236, 47, 84, 0.5)"></v-divider>
        <span class="button-font">알림 신청하기</span>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
  import { mapGetters } from 'vuex';

  export default {
    name: 'ProductCard',
    props: [ 'width', 'idx', 'title', 'subtitle', 'subtitle_color', 'publishedAt', 'status', 'thumbnail', 'bookmarks', 'alarms' ],
    computed: {
      ...mapGetters('user', { userIdx: 'idx' }),
      thumbnailSrc () {
        return this.thumbnail ? `${this.$storage}/store/${this.thumbnail}` : require('@/assets/img/thumbnail-default.png');
      }
    },
    data () {
      return {
        isClicked: false,
      };
    },
    methods: {
      readProduct (idx) {
        this.isClicked = true;
        window.setTimeout(() => {
          this.$router.push({ name: 'ReadProduct', params: { idx } });
        }, 200);
      },
      bookmark () {
        if (this.userIdx === 0) this.$router.replace({ name: 'SocialLogin', query: { redirect: this.$route.path }});
        else this.$emit('bookmark');
      },
      alarm () {
        if (this.userIdx === 0) this.$router.replace({ name: 'SocialLogin', query: { redirect: this.$route.path }});
        else this.$emit('alarm');
      }
    }
  }
</script>

<style lang="scss" scoped>
  .card-style-active {
      transform: scale(0.98);
    }

  .sub-text-style {
    font-size: 10px;
    letter-spacing: -0.2px;
    .sub-date {
      color: white;
    }
    .sub-title {
      font-weight: 700;
    }
  }

  .button-font {
    font-size: 13px;
  }

  .line-clamping {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    position: relative;
    z-index: 0;
  }
</style>
